import React, { ReactNode } from 'react';
import { Trans } from 'react-i18next';

export const SCOPE_DICT: Record<string, ReactNode> = {
  'user:base:read': <Trans i18nKey="Connect.userBase"></Trans>,
  'user:chain:read': <Trans i18nKey="Connect.userChain"></Trans>,
  'user:social:read': <Trans i18nKey="Connect.userSocial"></Trans>,
};
